import React, { useEffect, useState } from "react";
import { Badge, Button } from "antd";
import { ShoppingCartOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const LOCAL_STORAGE_STATE_KEY = "simolapps_state";

function FloatingCartButton() {
  const [count, setCount] = useState(0);
  const navigate = useNavigate();

  const getUserIdFromLocalStorage = () => {
    const state = localStorage.getItem(LOCAL_STORAGE_STATE_KEY);
    if (state) {
      try {
        const parsed = JSON.parse(state);
        return parsed?.user?.id || null;
      } catch (e) {
        console.error("Ошибка чтения localStorage:", e);
      }
    }
    return null;
  };

  useEffect(() => {
    const user_id = getUserIdFromLocalStorage();
    if (!user_id) return;

    fetch(`https://simolmedia.tw1.ru/api/get_download_queue.php?user_id=${user_id}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          if (Array.isArray(data.track_ids)) {
            setCount(data.track_ids.length);
          } else if (Array.isArray(data.tracks)) {
            setCount(data.tracks.length);
          } else if (typeof data.count === "number") {
            setCount(data.count);
          } else {
            setCount(0);
          }
        }
      })
      .catch((err) => {
        console.error("Ошибка при загрузке корзины:", err);
      });
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        bottom: 80,
        right: 20,
        zIndex: 999,
      }}
    >
      <Badge count={count} showZero>
        <Button
          type="primary"
          shape="circle"
          icon={<ShoppingCartOutlined />}
          size="large"
          onClick={() => navigate("/downloads/cart")}
        />
      </Badge>
    </div>
  );
}

export default FloatingCartButton;
